export enum PaymentProvider {
  Paynow = 'paynow',
  Transfer = 'transfer',
  Allegro = 'allegro',
  AppStore = 'app-store',
  GoogleStore = 'google-store',
  AppGallery = 'app-gallery',
}
